import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { Owned } from '../../base/named';
import { IAttribute } from 'app/model/base/annotation';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toArgsArray(argumentsModel: ParameterConfig[] | string, activity: any, attribute: IAttribute): any {
    if (argumentsModel && Array.isArray(argumentsModel) && argumentsModel.length > 0) {
        return argumentsModel.map((argument: ParameterConfig) => toResource(argument, ParameterConfig.VALUE));
    }

    const value = attribute.templateValue(activity);
    if (value !== undefined) {
        return {
            value,
            type: 'Expression'
        };
    }

    return undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toArgsString(activity: any, args: any, attribute: IAttribute): ParameterConfig[] | void {
    if (args && Array.isArray(args) && args.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return args.map((argument: any) => {
            const paramConfig = Owned.create<ParameterConfig>(ParameterConfig.MODEL, activity);
            toModel(paramConfig, ParameterConfig.VALUE, argument);
            return paramConfig;
        });
    }

    if (args) {
        if (args['type'] === 'Expression') {
            attribute.setTemplateValue(activity, args.value);
        } else if (typeof args === 'string' && isLogicAppExpression(args)) {
            attribute.setTemplateValue(activity, args);
        }
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toResource(object: {}, attribute: IAttribute): any {
    const value = attribute.templateValue(object);
    return value !== undefined ? value : attribute.value(object);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function toModel(object: {}, attribute: IAttribute, value: any): void {
    if (value == null) {
        return;
    }
    if (typeof value === 'string' && isLogicAppExpression(value)) {
        attribute.setTemplateValue(object, value);
    } else {
        attribute.setValue(object, value);
    }
}
